import { MenuAttendanceNavDocument, useMenuAttendanceNavQuery } from "apps/web/src/types";
import React from "react";
import { Route, Routes, useParams } from "react-router-dom-v5-compat";
import { getLink } from "../../../NavUtils";
import { RoleRoute } from "../../ProtectedRoutes";
import { NavLink } from "../../SecondaryNav/BreadCrumbs";
import { SecondaryNavLayout, SecondaryNavLayoutProps } from "../../SecondaryNav/SecondaryNavLayout";
import { kitchenLink, menuScheduleLink } from "../Kitchen/KitchenPaths";
import { MenuAttendancePage } from "./MenuAttendancePage";

export const getMenuAttendancePath = (mealMenuId: string) => `/org/menu-attendance/${mealMenuId}`;
export const getMenuAttendanceLink = (mealMenuId: string, mealMenuName: string) => getLink(mealMenuName, getMenuAttendancePath(mealMenuId));

const getSecondaryNavLayoutProps = (current: NavLink): SecondaryNavLayoutProps => ({
  name: "Org",
  current,
  breadCrumbs: [kitchenLink, menuScheduleLink],
  tabs: [],
  enableAthleteSearch: false,
});

export const MenuAttendanceRouter = () => {
  const { mealMenuId: maybeMealMenuId } = useParams();
  const mealMenuId = maybeMealMenuId || "";
  let mealMenuName = "";

  const { data, loading } = useMenuAttendanceNavQuery({ variables: { mealMenuId } });
  const refetchQueries = [{ query: MenuAttendanceNavDocument, variables: { mealMenuId } }];

  if (!loading && data) {
    const {
      mealMenu: { name },
    } = data;
    mealMenuName = name;
  }

  const current = getMenuAttendanceLink(mealMenuId, mealMenuName);
  const secondaryNavLayoutProps = getSecondaryNavLayoutProps(current);

  const teams = data ? data.mealMenu.teams : [];

  return (
    <Routes>
      <Route element={mealMenuName && <SecondaryNavLayout {...secondaryNavLayoutProps} />}>
        <Route element={<RoleRoute roles={["dietitian"]} />}>
          <Route
            index
            element={<MenuAttendancePage
              teams={[...teams]}
              refetchQueries={refetchQueries}
              mealMenuName={mealMenuName} />} />
        </Route>
      </Route>
    </Routes>
  );
};
